import {
  adaptVoucherRedeemResponse,
  type VoucherRedeemAdaptation
} from '../../../shared/api/intelliSightAdapters';
import { requestWithAuthRetry } from './authenticatedRequest';

export interface VoucherRedeemPayload {
  voucherCode: string;
}

export async function redeemVoucher(payload: VoucherRedeemPayload): Promise<VoucherRedeemAdaptation> {
  const response = await requestWithAuthRetry('POST', '/api/v1/vouchers/redeem', {
    json: {
      voucherCode: payload.voucherCode
    },
    retryLabel: 'voucherRedeem'
  });
  return adaptVoucherRedeemResponse(response);
}
